import { channel } from '../utils/broadcast';

export function subscribeChannel(handler) {
    
    channel.addEventListener('message', handler);

    return () => {
        channel.removeEventListener('message', handler);
    };

}

export function publishChannel(tipo, payload) {
    channel.postMessage({tipo, payload});
}